
namespace TabAurous.Administration {

    @Serenity.Decorators.registerClass()
    export class CampaignSetupDialog extends Serenity.EntityDialog<CampaignSetupRow, any> {
        protected getFormKey() { return CampaignSetupForm.formKey; }
        protected getIdProperty() { return CampaignSetupRow.idProperty; }
        protected getLocalTextPrefix() { return CampaignSetupRow.localTextPrefix; }
        protected getNameProperty() { return CampaignSetupRow.nameProperty; }
        protected getService() { return CampaignSetupService.baseUrl; }
        protected getDeletePermission() { return CampaignSetupRow.deletePermission; }
        protected getInsertPermission() { return CampaignSetupRow.insertPermission; }
        protected getUpdatePermission() { return CampaignSetupRow.updatePermission; }

        protected form = new CampaignSetupForm(this.idPrefix);
        constructor() {
            super();
            this.form.Type.changeSelect2(e => {
                this.form.Provider.cascadeField = "Num1";
                var x = this.form.Type.value;
                this.form.Provider.cascadeValue = this.form.Type.value;
                if (this.form.Type.value.toString() == "251") {
                    q.showField(this.form.Password);
                    q.showField(this.form.UserName, true);                    
                } else {
                    q.hideField(this.form.Password);
                    q.showField(this.form.UserName);
                }
                q.setEditorLabel(this.form.UserName, OMS.FixedCodeRow.getLookup().itemById[parseInt(this.form.Type.value)].FixedName + " From");
                


            });
        }
        protected onDialogOpen() {
            super.onDialogOpen();
            if (this.form.Type.value.toString() != "") {
                this.form.Provider.cascadeValue = this.form.Type.value;
                if (this.form.Type.value.toString() == "251") {
                    q.showField(this.form.Password);
                    q.showField(this.form.UserName, true);
                } else {
                    q.hideField(this.form.Password);
                    q.showField(this.form.UserName);
                }
                q.setEditorLabel(this.form.UserName, OMS.FixedCodeRow.getLookup().itemById[parseInt(this.form.Type.value)].FixedName + " From");
            } else {
                Serenity.EditorUtils.setRequired(this.form.Password, false);
                Serenity.EditorUtils.setRequired(this.form.UserName, false);
            }
        }
    }
}